var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',{attrs:{"height":330}},[_c('rect',{attrs:{"x":"75","y":"15","rx":"10","ry":"10","width":"250","height":"250"}})])}
var staticRenderFns = []

export { render, staticRenderFns }